export default "__VITE_ASSET__CVIyaZJX__"